var React = require('react');

function DashboardIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.0258 0L9.02606 5.99974V3.59917H4.22604V10.7998L0 15.0258L0.848585 15.8744L15.0258 1.69717L29.203 15.8744L30.0516 15.0258L15.0258 0ZM5.42577 4.80002H7.82521V7.19947L5.42464 9.60004V4.80002H5.42577Z","fill":"#555555","key":0}),React.createElement("path",{"d":"M4.2262 15.6001V30.0001H12.6265V21.5998H17.4265V30.0001H25.8269V15.6001L15.0271 4.80029L4.22732 15.6001H4.2262ZM24.626 28.8004H18.6263V20.4001H11.4257V28.8004H5.42592V16.0975L15.026 6.49746L24.626 16.0975V28.8004Z","fill":"#555555","key":1})]);
}

DashboardIcon.defaultProps = {"width":"31","height":"30","viewBox":"0 0 31 30","fill":"none"};

module.exports = DashboardIcon;

DashboardIcon.default = DashboardIcon;
